module.exports = __webpack_public_path__ + "static/media/stellated_dodecahedron.dd34bf06.png";